/**
 * @generated SignedSource<<96c88c54eb5d4098189bbc2dbff4fb1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestAccessTooltip_note$data = {
  readonly id: string;
  readonly pendingAccessRequests: ReadonlyArray<{
    readonly createdAt: string;
    readonly id: string;
    readonly requestor: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isExternal: boolean;
    };
  }>;
  readonly " $fragmentType": "RequestAccessTooltip_note";
};
export type RequestAccessTooltip_note$key = {
  readonly " $data"?: RequestAccessTooltip_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestAccessTooltip_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestAccessTooltip_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteAccessRequestNode",
      "kind": "LinkedField",
      "name": "pendingAccessRequests",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "requestor",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "3408927af5ba3bb50a73b7e8c7367f9a";

export default node;
